import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { jsxs, jsx } from 'react/jsx-runtime';
import { Events, CognitoFederatedProviders } from '@phx-husky/auth-service';
import { Button as Button$1 } from '@phx-husky/button-auth';
import { triggerCustomEvent } from '@phx-husky/custom-event';
import { Field, FieldType, ConditionalWrapper } from '@phx-husky/field';
import { CloseIcon } from '@phx-husky/icons';
import { Modal } from '@phx-husky/modal';
import { useConfig } from '@phx-husky/use-config';
import classNames from 'classnames';
import { useState, useCallback, useEffect, useMemo } from 'react';
import { Button } from '@design-system/button';
import { ErrorMessage } from '@design-system/error-message';
import { Typography } from '@design-system/typography';
import { InformationModal } from '@phx-husky/information-modal';
import { useForgotPassword } from '@phx-husky/use-forgot-password';
import { useTranslations } from '@phx-husky/use-translations';
import { Loader } from '@phx-husky/loader';
import SocialMediaLoginButton, { SocialMediaProvider } from '@phx-husky/social-media-login-button';
import { useSignIn } from '@phx-husky/use-sign-in';
import { CheckboxField } from '@design-system/checkbox-field';
import AccountConfirmationModal, { ConfirmationMode } from '@phx-husky/account-confirmation';
import { useForm } from '@phx-husky/use-form';
import { useSignUp } from '@phx-husky/use-sign-up';
import { useUserSession } from '@phx-husky/use-user-session';
function __rest(s, e) {
  var t = {};
  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z$1 = ".forgot-password-module_container__qkjaV {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n.forgot-password-module_form__tkpyD {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n.forgot-password-module_title__E6EKC {\n  align-self: start;\n  color: var(--phx-textColor, #101010);\n}\n\n.forgot-password-module_description__TevMb {\n  margin: var(--cds-space-5) 0 var(--cds-space-6) 0;\n  color: var(--phx-secondaryTextColor, #4a4a4a);\n}\n\n.forgot-password-module_infoLabel__aaszG {\n  margin: var(--cds-space-5) 0 var(--cds-space-3) 0;\n  color: var(--phx-secondaryTextColor, #4a4a4a);\n}\n\n.forgot-password-module_loginBackButton__7swYc {\n  align-self: center;\n  margin: var(--cds-space-6) auto;\n}\n\n.forgot-password-module_loginBackText__dnQ1I {\n  color: var(--phx-textColor, #101010);\n}\n\n.forgot-password-module_submit__SVfcm {\n  width: 100%;\n}\n\n.forgot-password-module_additionalInfoMessage__ObfmZ {\n  margin: var(--cds-space-2) 0;\n  color: var(--phx-secondaryTextColor, #4a4a4a);\n}\n\n.forgot-password-module_errorMessage__kNVWX {\n  margin: var(--cds-space-2) 0;\n}\n\n.forgot-password-module_errorMessage__kNVWX.cds-error-icon {\n  margin: 0px;\n  width: var(--cds-icon-size-xs);\n  height: var(--cds-icon-size-xs);\n}\n\n.forgot-password-module_centerSubactions__LWuGX {\n  text-align: center;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles$1 = {
  "container": "forgot-password-module_container__qkjaV",
  "form": "forgot-password-module_form__tkpyD",
  "title": "forgot-password-module_title__E6EKC",
  "description": "forgot-password-module_description__TevMb",
  "infoLabel": "forgot-password-module_infoLabel__aaszG",
  "loginBackButton": "forgot-password-module_loginBackButton__7swYc",
  "loginBackText": "forgot-password-module_loginBackText__dnQ1I",
  "submit": "forgot-password-module_submit__SVfcm",
  "additionalInfoMessage": "forgot-password-module_additionalInfoMessage__ObfmZ",
  "errorMessage": "forgot-password-module_errorMessage__kNVWX",
  "centerSubactions": "forgot-password-module_centerSubactions__LWuGX"
};
styleInject(css_248z$1);
var initialValues = {
  email: '',
  code: '',
  password: '',
  confirmPassword: ''
};
var ForgotPassword$1 = function ForgotPassword$1(_ref) {
  var onClickSignIn = _ref.onClickSignIn,
    onClickPasswordChanged = _ref.onClickPasswordChanged,
    onHandleConfirmAccount = _ref.onHandleConfirmAccount,
    confirmedEmailReturn = _ref.confirmedEmailReturn;
  var _a, _b, _c, _d, _e, _f, _g;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isCodeSent = _useState2[0],
    setIsCodeSent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    noConfirmedAccount = _useState4[0],
    setNoConfirmedAccount = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    error = _useState6[0],
    setError = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    message = _useState8[0],
    setMessage = _useState8[1];
  var _useTranslations = useTranslations(),
    translate = _useTranslations.translate;
  var _useState9 = useState({}),
    _useState10 = _slicedToArray(_useState9, 2),
    fieldErrors = _useState10[0],
    setFieldErrors = _useState10[1];
  var _useState11 = useState(Object.assign(Object.assign({}, initialValues), {
      email: confirmedEmailReturn || ''
    })),
    _useState12 = _slicedToArray(_useState11, 2),
    values = _useState12[0],
    setValues = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    medium = _useState14[0],
    setMedium = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    destination = _useState16[0],
    setDestination = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    congratulationInfo = _useState18[0],
    setCongratulationInfo = _useState18[1];
  var _useForgotPassword = useForgotPassword(),
    forgotPassword = _useForgotPassword.forgotPassword,
    forgotPasswordSubmit = _useForgotPassword.forgotPasswordSubmit,
    validate = _useForgotPassword.validate;
  var handleChange = function handleChange(fieldValue) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var name, value, validation;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              name = '';
              value = '';
              if (fieldValue.target) {
                name = fieldValue.target.name;
                value = fieldValue.target.value;
              } else {
                name = fieldValue.name;
                value = fieldValue.value;
              }
              setValues(function (prev) {
                return Object.assign(Object.assign({}, prev), _defineProperty({}, name, value));
              });
              _context.next = 6;
              return validate(Object.assign(Object.assign({}, values), _defineProperty({}, name, value)));
            case 6:
              validation = _context.sent;
              setFieldErrors(function (prev) {
                return Object.assign(Object.assign(Object.assign({}, prev), validation), {
                  validation: Object.assign(Object.assign({}, prev.validation), validation.validation)
                });
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  };
  var handleSubmitForgotPassword = useCallback(function (e) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _h, emailValidation, result, isSafeException;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (e) {
                e === null || e === void 0 ? void 0 : e.preventDefault();
              }
              _context2.next = 3;
              return validate({
                email: values.email
              });
            case 3:
              emailValidation = _context2.sent;
              setFieldErrors(emailValidation);
              if (emailValidation.valid) {
                _context2.next = 7;
                break;
              }
              return _context2.abrupt("return");
            case 7:
              _context2.next = 9;
              return forgotPassword(values.email);
            case 9:
              result = _context2.sent;
              isSafeException = ['CodeDeliveryFailureException', 'UserNotFoundException'].includes(result.code);
              if (!(result.code === 'InvalidParameterException')) {
                _context2.next = 14;
                break;
              }
              setNoConfirmedAccount(true);
              return _context2.abrupt("return");
            case 14:
              setIsCodeSent(true);
              if (isSafeException) {
                setMessage(result.translatedMessage);
              } else if (result.success) {
                setMessage(translate("UserNotFoundExceptionForgotPassword".concat((_h = result.CodeDeliveryDetails) === null || _h === void 0 ? void 0 : _h.DeliveryMedium)));
              } else {
                setError((result === null || result === void 0 ? void 0 : result.translatedMessage) || (result === null || result === void 0 ? void 0 : result.message) || '');
              }
              if (result.CodeDeliveryDetails) {
                setMedium(result.CodeDeliveryDetails.DeliveryMedium);
                setDestination(result.CodeDeliveryDetails.Destination);
              }
            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
  }, [forgotPassword, translate, validate, values.email]);
  useEffect(function () {
    if (!confirmedEmailReturn) return;
    handleSubmitForgotPassword();
  }, [confirmedEmailReturn]);
  var onForgotSubmitClick = function onForgotSubmitClick() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var validation, result;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              setMessage('');
              _context3.next = 3;
              return validate({
                password: values.password,
                confirmPassword: values.confirmPassword,
                confirmationCode: values.code,
                email: values.email
              });
            case 3:
              validation = _context3.sent;
              setFieldErrors(validation);
              if (validation.valid) {
                _context3.next = 7;
                break;
              }
              return _context3.abrupt("return");
            case 7:
              _context3.next = 9;
              return forgotPasswordSubmit({
                username: values.email,
                code: values.code,
                newPassword: values.password
              });
            case 9:
              result = _context3.sent;
              if (result.success) {
                setCongratulationInfo(true);
              } else {
                setError((result === null || result === void 0 ? void 0 : result.translatedMessage) || result.message || '');
              }
            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  };
  var close = function close() {
    triggerCustomEvent(Events.onForgotPasswordClick, {
      visible: false
    });
  };
  var openLoginModal = function openLoginModal() {
    triggerCustomEvent(Events.onSignInClick, {
      visible: true
    });
  };
  var handleSignInClick = function handleSignInClick() {
    if (onClickSignIn) {
      onClickSignIn();
    } else {
      close();
      openLoginModal();
    }
  };
  return jsxs("div", Object.assign({
    className: classNames(styles$1.container, 'forgot-password__container')
  }, {
    children: [isCodeSent && !congratulationInfo ? jsx(Typography, {
      tag: "h2",
      variant: "headline",
      size: "m",
      weight: "bold",
      className: styles$1.title,
      "data-translate-key": "forgotPasswordWelcome",
      content: "".concat(translate('forgotPasswordWelcome'), " ").concat(values.email)
    }) : null, !isCodeSent && !congratulationInfo ? jsx(Typography, {
      tag: "h2",
      variant: "headline",
      size: "m",
      weight: "bold",
      className: styles$1.title,
      "data-translate-key": "forgotPasswordTitle",
      content: translate('forgotPasswordTitle')
    }) : null, isCodeSent && !congratulationInfo ? jsxs("form", Object.assign({
      id: "forgot-form",
      className: classNames(styles$1.form, 'forgot-password__form')
    }, {
      children: [jsx(Typography, {
        tag: "p",
        variant: "body",
        size: "m",
        className: classNames(styles$1.infoLabel, 'forgot-password__info-label'),
        "data-translate-key": "forgotPasswordProvideCode".concat(medium),
        content: translate("forgotPasswordProvideCode".concat(medium), translate('forgotPasswordProvideCode'), destination)
      }), jsx(Field, {
        id: "code",
        name: "code",
        type: FieldType.textbox,
        "data-translate-key": "forgotPasswordConfirmationCode",
        label: translate('forgotPasswordConfirmationCode'),
        value: values.code,
        onChange: handleChange,
        errorMessage: (_b = (_a = fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.validation) === null || _a === void 0 ? void 0 : _a.confirmationCode) === null || _b === void 0 ? void 0 : _b.message
      }, "code"), jsx(Typography, {
        tag: "p",
        variant: "body",
        size: "m",
        className: classNames(styles$1.infoLabel, 'forgot-password__info-label'),
        "data-translate-key": "forgotPasswordProvidePassword",
        content: translate('forgotPasswordProvidePassword')
      }), jsx(Field, {
        id: "password",
        name: "password",
        type: FieldType.password,
        "data-translate-key": "forgotPassword",
        label: translate('forgotPassword'),
        value: values.password,
        onChange: handleChange,
        errorMessage: (_d = (_c = fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.validation) === null || _c === void 0 ? void 0 : _c.password) === null || _d === void 0 ? void 0 : _d.message
      }, "password"), jsx(Field, {
        id: "confirmPassword",
        name: "confirmPassword",
        type: FieldType.password,
        "data-translate-key": "forgotPasswordConfirmPassword",
        label: translate('forgotPasswordConfirmPassword'),
        value: values.confirmPassword,
        onChange: handleChange,
        errorMessage: (_f = (_e = fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.validation) === null || _e === void 0 ? void 0 : _e.confirmPassword) === null || _f === void 0 ? void 0 : _f.message
      }, "confirmPassword"), jsx(Button, Object.assign({
        type: "button",
        variant: "subtle",
        className: classNames(styles$1.loginBackButton, 'login__back-button'),
        onClick: handleSignInClick,
        id: "login-back-button"
      }, {
        children: jsx(Typography, {
          tag: "span",
          variant: "body",
          size: "s",
          className: styles$1.loginBackText,
          "data-translate-key": "forgotPasswordSignInInformationSubtitle",
          content: "".concat(translate('forgotPasswordSignInInformationSubtitle'), " <strong>").concat(translate('forgotPasswordSignInInformationButton'), "</strong>")
        })
      })), jsx(Button, Object.assign({
        type: "button",
        variant: "primary",
        size: "large",
        className: classNames(styles$1.submit, 'forgot-password__submit'),
        onClick: onForgotSubmitClick,
        id: "forgot-password-confirm",
        "data-translate-key": "forgotPasswordConfirmButton"
      }, {
        children: translate('forgotPasswordConfirmButton')
      })), error ? jsx(ErrorMessage, {
        className: classNames(styles$1.errorMessage, 'forgot-password__error'),
        message: error
      }) : null, message ? jsx(Typography, {
        tag: "p",
        variant: "body",
        size: "s",
        className: styles$1.additionalInfoMessage,
        content: message
      }) : null]
    })) : null, !isCodeSent && !congratulationInfo ? jsxs("form", Object.assign({
      onSubmit: handleSubmitForgotPassword
    }, {
      children: [jsx(Typography, {
        tag: "p",
        variant: "body",
        size: "m",
        className: styles$1.description,
        "data-translate-key": "forgotPasswordProvideEmail",
        content: translate('forgotPasswordProvideEmail')
      }), jsx(Field, {
        id: "email",
        name: "email",
        type: FieldType.textbox,
        label: "Email",
        value: values.email,
        onChange: handleChange,
        errorMessage: (_g = fieldErrors === null || fieldErrors === void 0 ? void 0 : fieldErrors.validation) === null || _g === void 0 ? void 0 : _g.email.message
      }, "email"), jsxs("div", Object.assign({
        className: styles$1.centerSubactions
      }, {
        children: [noConfirmedAccount && onHandleConfirmAccount ? jsx(Button, Object.assign({
          type: "button",
          variant: "subtle",
          onClick: function onClick() {
            return onHandleConfirmAccount({
              reconfirmEmail: values.email
            });
          }
        }, {
          children: jsx(ErrorMessage, {
            className: classNames(styles$1.errorMessage, 'login__error'),
            message: translate('forgotPasswordNoConfirmedError')
          })
        })) : null, jsx(Button, Object.assign({
          type: "button",
          variant: "subtle",
          className: classNames(styles$1.loginBackButton, 'login__back-button'),
          onClick: handleSignInClick,
          id: "login-back-button"
        }, {
          children: jsx(Typography, {
            tag: "span",
            variant: "body",
            size: "s",
            "data-translate-key": "forgotPasswordSignInInformationSubtitle",
            className: styles$1.loginBackText,
            content: "".concat(translate('forgotPasswordSignInInformationSubtitle'), " <strong>").concat(translate('forgotPasswordSignInInformationButton'), "</strong>")
          })
        }))]
      })), jsx(Button, Object.assign({
        type: "submit",
        variant: "primary",
        size: "large",
        className: classNames(styles$1.submit, 'forgot-password__submit'),
        id: "forgot-password-send-code",
        "data-translate-key": "forgotPasswordSendCodeButton"
      }, {
        children: translate('forgotPasswordSendCodeButton')
      })), error ? jsx(ErrorMessage, {
        className: classNames(styles$1.errorMessage, 'forgot-password__error'),
        message: error
      }) : null]
    })) : null, congratulationInfo ? jsx(InformationModal, {
      message: translate('forgotPasswordCongratulationText'),
      title: translate('forgotPasswordCongratulationTitle'),
      buttonTitle: translate('forgotPasswordCongratulationButton'),
      callback: onClickPasswordChanged
    }) : null]
  }));
};
var css_248z = ".login-module_login__9jdwx,\n.login-module_forgotPassword__Qysm4 {\n  width: 100%;\n  font-family: var(--phx-fontFamily, Lato, sans-serif);\n  padding: var(--phx-loginModalPadding, var(--cds-space-6) var(--cds-space-3));\n  margin: 0 auto;\n}\n\n@media screen and (min-width: 576px) {\n  .login-module_login__9jdwx,\n.login-module_forgotPassword__Qysm4 {\n    width: var(--phx-loginModalWidth, 360px);\n  }\n}\n\n.login-module_container__usTL- {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n.login-module_form__FxqLu {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n}\n\n.login-module_logo__McXvL {\n  margin-bottom: var(--cds-space-3);\n}\n\n.login-module_title__lg-Vf {\n  align-self: start;\n  color: var(--phx-textColor, #101010);\n}\n\n.login-module_description__n2ToS {\n  margin: var(--cds-space-5) 0 var(--cds-space-7) 0;\n  color: var(--phx-secondaryTextColor, #4a4a4a);\n}\n\n.login-module_switchModeWrapper__b-mYN {\n  align-self: center;\n  margin: var(--cds-space-6) auto;\n}\n\n.login-module_switchModeText__Gut1S {\n  color: var(--phx-textColor, #101010);\n}\n\n.login-module_forgotPasswordButton__VDeC- {\n  align-self: start;\n}\n\n.login-module_forgotPasswordText__8iHPc {\n  color: var(--phx-secondaryTextColor, #4a4a4a);\n  text-decoration: underline;\n}\n\n.login-module_rememberContainer__kORsg {\n  display: flex;\n  align-items: center;\n  margin: var(--cds-space-2) 0 var(--cds-space-3) 0;\n}\n\n.login-module_rememberContainer__kORsg .cds-checkbox-field span {\n  font-size: 1rem;\n}\n\n.login-module_submit__f9eeU {\n  width: 100%;\n}\n\n.login-module_errorMessage__02fN- {\n  margin: var(--cds-space-2) 0;\n}\n\n.login-module_errorMessage__02fN-.cds-error-icon {\n  margin: 0px;\n  width: var(--cds-icon-size-xs);\n  height: var(--cds-icon-size-xs);\n}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var styles = {
  "login": "login-module_login__9jdwx",
  "forgotPassword": "login-module_forgotPassword__Qysm4",
  "container": "login-module_container__usTL-",
  "form": "login-module_form__FxqLu",
  "logo": "login-module_logo__McXvL",
  "title": "login-module_title__lg-Vf",
  "description": "login-module_description__n2ToS",
  "switchModeWrapper": "login-module_switchModeWrapper__b-mYN",
  "switchModeText": "login-module_switchModeText__Gut1S",
  "forgotPasswordButton": "login-module_forgotPasswordButton__VDeC-",
  "forgotPasswordText": "login-module_forgotPasswordText__8iHPc",
  "rememberContainer": "login-module_rememberContainer__kORsg",
  "submit": "login-module_submit__f9eeU",
  "errorMessage": "login-module_errorMessage__02fN-"
};
styleInject(css_248z);
var ForgotPassword = function ForgotPassword(_ref2) {
  var onClickSignIn = _ref2.onClickSignIn,
    onClickPasswordChanged = _ref2.onClickPasswordChanged,
    _ref2$renderAs = _ref2.renderAs,
    Wrapper = _ref2$renderAs === void 0 ? Modal : _ref2$renderAs,
    _ref2$isWrapperCompon = _ref2.isWrapperComponent,
    isWrapperComponent = _ref2$isWrapperCompon === void 0 ? true : _ref2$isWrapperCompon,
    onHandleConfirmAccount = _ref2.onHandleConfirmAccount,
    confirmedEmailReturn = _ref2.confirmedEmailReturn;
  var _useConfig = useConfig(),
    renderLogo = _useConfig.renderLogo;
  var close = function close() {
    triggerCustomEvent(Events.onForgotPasswordClick, {
      visible: false
    });
  };
  var WrapperComponent = useCallback(function (children) {
    return jsx(Wrapper, Object.assign({
      isShowing: true,
      close: close,
      disableOnClickClose: true,
      className: styles.modal
    }, {
      children: children
    }));
  }, []);
  return jsx(ConditionalWrapper, Object.assign({
    condition: isWrapperComponent,
    wrapper: WrapperComponent
  }, {
    children: jsxs("div", Object.assign({
      className: classNames(styles.forgotPassword, 'forgot-password')
    }, {
      children: [isWrapperComponent ? jsx(Button$1, Object.assign({
        variant: "close",
        onClick: close,
        type: "button",
        className: "forgot-password__close-button"
      }, {
        children: jsx(CloseIcon, {})
      })) : null, renderLogo ? renderLogo({
        className: styles.logo
      }) : null, jsx(ForgotPassword$1, {
        onClickSignIn: onClickSignIn,
        onClickPasswordChanged: onClickPasswordChanged,
        onHandleConfirmAccount: onHandleConfirmAccount,
        confirmedEmailReturn: confirmedEmailReturn
      })]
    }))
  }));
};
var LoginForm = function LoginForm(_ref3) {
  var loginFields = _ref3.loginFields,
    onClickForgotPassword = _ref3.onClickForgotPassword,
    onClickSignUp = _ref3.onClickSignUp,
    onConfirmationCallback = _ref3.onConfirmationCallback;
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    submitPending = _useState20[0],
    setSubmitPending = _useState20[1];
  var _useState21 = useState(''),
    _useState22 = _slicedToArray(_useState21, 2),
    error = _useState22[0],
    setError = _useState22[1];
  var _useState23 = useState(),
    _useState24 = _slicedToArray(_useState23, 2),
    accountConfirmationInfo = _useState24[0],
    setAccountConfirmationInfo = _useState24[1];
  var _useSignIn = useSignIn(),
    signIn = _useSignIn.signIn,
    validate = _useSignIn.validate;
  var _useTranslations2 = useTranslations(),
    translate = _useTranslations2.translate;
  var _useUserSession = useUserSession(),
    setRememberMe = _useUserSession.setRememberMe,
    getRememberMeConfig = _useUserSession.getRememberMeConfig;
  var _useSignUp = useSignUp(),
    resendSignUpCode = _useSignUp.resendSignUpCode;
  var rememberMeConfig = getRememberMeConfig();
  var _useState25 = useState(rememberMeConfig.defaultValue),
    _useState26 = _slicedToArray(_useState25, 2),
    remember = _useState26[0],
    setRemember = _useState26[1];
  var fieldStatesInit = useMemo(function () {
    return Object.keys(loginFields).reduce(function (prev, curr) {
      return Object.assign(Object.assign({}, prev), _defineProperty({}, curr, ''));
    }, {});
  }, [loginFields]);
  var close = function close() {
    var payload = {
      visible: false
    };
    triggerCustomEvent(Events.onSignInClick, payload);
  };
  var showAccountConfirmationInfo = function showAccountConfirmationInfo(emailAddress) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _a, _b, _c, resendResult, accountConfirmInfo;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return resendSignUpCode({
                username: emailAddress.toLowerCase()
              });
            case 2:
              resendResult = _context4.sent;
              if (resendResult.success) {
                accountConfirmInfo = {
                  email: emailAddress,
                  medium: (_a = resendResult.CodeDeliveryDetails) === null || _a === void 0 ? void 0 : _a.DeliveryMedium,
                  destination: (_b = resendResult.CodeDeliveryDetails) === null || _b === void 0 ? void 0 : _b.Destination,
                  field: (_c = resendResult.CodeDeliveryDetails) === null || _c === void 0 ? void 0 : _c.AttributeName,
                  visible: true
                };
                setAccountConfirmationInfo(accountConfirmInfo);
              }
            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
  };
  var onLoginClick = function onLoginClick(data) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var result, unauthorizedCodes, userIsUnauthorized;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              setSubmitPending(true);
              if (rememberMeConfig.show) {
                setRememberMe({
                  storage: remember ? window.localStorage : window.sessionStorage
                });
              }
              _context5.next = 4;
              return signIn({
                email: data.email,
                password: data.loginPassword
              });
            case 4:
              result = _context5.sent;
              if (result === null || result === void 0 ? void 0 : result.success) {
                close();
              } else {
                unauthorizedCodes = ['UserNotConfirmedException'];
                userIsUnauthorized = unauthorizedCodes.find(function (code) {
                  return code === result.code;
                });
                if (userIsUnauthorized) {
                  showAccountConfirmationInfo(data.email);
                  close();
                } else if (result === null || result === void 0 ? void 0 : result.translatedMessage) {
                  setError(result.translatedMessage);
                }
              }
              setSubmitPending(false);
            case 7:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));
  };
  var openRegisterModal = function openRegisterModal() {
    triggerCustomEvent(Events.onSignUpClick, {
      visible: true
    });
  };
  var openForgotModal = function openForgotModal() {
    triggerCustomEvent(Events.onForgotPasswordClick, {
      visible: true
    });
  };
  var handleForgotPasswordClick = function handleForgotPasswordClick() {
    if (onClickForgotPassword) {
      onClickForgotPassword();
    } else {
      close();
      openForgotModal();
    }
  };
  var _useForm = useForm({
      initialValues: fieldStatesInit,
      callback: onLoginClick,
      validate: validate,
      validateOnChange: true
    }),
    values = _useForm.values,
    errors = _useForm.errors,
    handleChange = _useForm.handleChange,
    handleSubmit = _useForm.handleSubmit;
  return !(accountConfirmationInfo === null || accountConfirmationInfo === void 0 ? void 0 : accountConfirmationInfo.visible) ? jsxs("form", Object.assign({
    id: "login-form",
    onSubmit: handleSubmit,
    className: classNames(styles.form, 'login__form')
  }, {
    children: [jsx(Typography, {
      tag: "h2",
      variant: "headline",
      size: "m",
      weight: "bold",
      "data-translate-key": "loginTitle",
      content: translate('loginTitle')
    }), jsx(Typography, {
      variant: "body",
      tag: "p",
      size: "m",
      className: styles.description,
      "data-translate-key": "loginDescription",
      content: translate('loginDescription')
    }), Object.entries(loginFields).map(function (_a) {
      var _b;
      var _a2 = _slicedToArray(_a, 2),
        name = _a2[0],
        _c = _a2[1],
        id = _c.id,
        label = _c.label,
        type = _c.type,
        rest = __rest(_c, ["id", "label", "type"]);
      return jsx(Field, Object.assign({
        id: id,
        name: name,
        type: FieldType[type],
        label: label,
        value: values[name],
        onChange: handleChange,
        errorMessage: (_b = errors === null || errors === void 0 ? void 0 : errors.validation) === null || _b === void 0 ? void 0 : _b[name].message
      }, rest), id);
    }), rememberMeConfig.show ? jsx("div", Object.assign({
      className: classNames(styles.rememberContainer, 'login__remember-container')
    }, {
      children: jsx(CheckboxField, {
        id: "rememberMe",
        name: "rememberMe",
        label: translate('loginRememberMe'),
        value: "true",
        checked: remember,
        onChange: function onChange(e) {
          return setRemember(e.target.checked);
        }
      }, "rememberMe")
    })) : null, jsx(Button, Object.assign({
      type: "button",
      variant: "subtle",
      className: styles.forgotPasswordButton,
      id: "forgot-password-button",
      onClick: handleForgotPasswordClick
    }, {
      children: jsx(Typography, {
        tag: "span",
        variant: "body",
        size: "s",
        weight: "bold",
        className: styles.forgotPasswordText,
        "data-translate-key": "loginForgotPasswordButton",
        content: translate('loginForgotPasswordButton')
      })
    })), jsx("div", Object.assign({
      className: styles.switchModeWrapper
    }, {
      children: jsx(Button, Object.assign({
        type: "button",
        variant: "subtle",
        className: styles.switchModeButton,
        id: "login-switch-mode-button",
        onClick: function onClick() {
          if (onClickSignUp) {
            onClickSignUp();
          } else {
            close();
            openRegisterModal();
          }
        }
      }, {
        children: jsx(Typography, {
          tag: "span",
          variant: "body",
          size: "s",
          className: styles.switchModeText,
          "data-translate-key": "loginSignUpInformationSubtitle",
          content: "".concat(translate('loginSignUpInformationSubtitle'), " <strong>").concat(translate('loginSignUpInformationButton'), "</strong>")
        })
      }))
    })), jsx(Button, Object.assign({
      type: "submit",
      variant: "primary",
      size: "large",
      className: classNames(styles.submit, 'login__submit'),
      id: "login-submit",
      "data-translate-key": "loginSubmitButton",
      isLoading: submitPending,
      disabled: submitPending
    }, {
      children: translate('loginSubmitButton')
    })), error ? jsx(ErrorMessage, {
      className: classNames(styles.errorMessage, 'login__error'),
      message: error
    }) : null]
  })) : jsx(AccountConfirmationModal, {
    mode: ConfirmationMode.AccountConfirmation,
    email: accountConfirmationInfo === null || accountConfirmationInfo === void 0 ? void 0 : accountConfirmationInfo.email,
    codeDeliveryMedium: accountConfirmationInfo === null || accountConfirmationInfo === void 0 ? void 0 : accountConfirmationInfo.medium,
    attributeName: accountConfirmationInfo === null || accountConfirmationInfo === void 0 ? void 0 : accountConfirmationInfo.field,
    attributeValue: accountConfirmationInfo === null || accountConfirmationInfo === void 0 ? void 0 : accountConfirmationInfo.destination,
    title: accountConfirmationInfo === null || accountConfirmationInfo === void 0 ? void 0 : accountConfirmationInfo.title,
    onConfirmationCallback: onConfirmationCallback
  });
};
var Login = function Login(_ref4) {
  var onClickSignUp = _ref4.onClickSignUp,
    onClickForgotPassword = _ref4.onClickForgotPassword,
    _ref4$renderAs = _ref4.renderAs,
    Wrapper = _ref4$renderAs === void 0 ? Modal : _ref4$renderAs,
    _ref4$isWrapperCompon = _ref4.isWrapperComponent,
    isWrapperComponent = _ref4$isWrapperCompon === void 0 ? true : _ref4$isWrapperCompon,
    onConfirmationCallback = _ref4.onConfirmationCallback;
  var _useState27 = useState(true),
    _useState28 = _slicedToArray(_useState27, 2),
    pending = _useState28[0],
    setPending = _useState28[1];
  var _useState29 = useState({}),
    _useState30 = _slicedToArray(_useState29, 2),
    loginFields = _useState30[0],
    setLoginFields = _useState30[1];
  var _useSignIn2 = useSignIn(),
    federatedSignIn = _useSignIn2.federatedSignIn,
    getAvailableSocialSignIn = _useSignIn2.getAvailableSocialSignIn,
    getSignInFields = _useSignIn2.getSignInFields;
  var _useConfig2 = useConfig(),
    renderLogo = _useConfig2.renderLogo;
  var _getAvailableSocialSi = getAvailableSocialSignIn(),
    facebookSignInAvailable = _getAvailableSocialSi.Facebook,
    googleSignInAvailable = _getAvailableSocialSi.Google,
    appleSignInAvailable = _getAvailableSocialSi.Apple;
  var getSignInFieldsInit = function getSignInFieldsInit() {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var fields;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              setPending(true);
              _context6.prev = 1;
              _context6.next = 4;
              return getSignInFields();
            case 4:
              fields = _context6.sent;
              setLoginFields(fields);
              setPending(false);
              _context6.next = 12;
              break;
            case 9:
              _context6.prev = 9;
              _context6.t0 = _context6["catch"](1);
              setPending(false);
            case 12:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1, 9]]);
    }));
  };
  useEffect(function () {
    getSignInFieldsInit();
  }, []);
  var close = function close() {
    var payload = {
      visible: false
    };
    triggerCustomEvent(Events.onSignInClick, payload);
  };
  var federatedSignInClick = function federatedSignInClick(provider) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return federatedSignIn({
                provider: CognitoFederatedProviders[provider]
              });
            case 2:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));
  };
  var WrapperComponent = useCallback(function (children) {
    return jsx(Wrapper, Object.assign({
      isShowing: true,
      close: close,
      disableOnClickClose: true,
      className: styles.modal
    }, {
      children: children
    }));
  }, []);
  return jsx(ConditionalWrapper, Object.assign({
    condition: isWrapperComponent,
    wrapper: WrapperComponent
  }, {
    children: jsxs("div", Object.assign({
      className: classNames(styles.login, 'login'),
      id: "login"
    }, {
      children: [isWrapperComponent ? jsx(Button$1, Object.assign({
        variant: "close",
        onClick: close,
        type: "button",
        className: "login__close-button"
      }, {
        children: jsx(CloseIcon, {})
      })) : null, renderLogo ? renderLogo({
        className: styles.logo
      }) : null, jsxs("div", Object.assign({
        className: classNames(styles.container, 'login__container')
      }, {
        children: [pending ? jsx(Loader, {}) : jsx(LoginForm, {
          loginFields: loginFields,
          onClickForgotPassword: onClickForgotPassword,
          onClickSignUp: onClickSignUp,
          onConfirmationCallback: onConfirmationCallback
        }), facebookSignInAvailable ? jsx(SocialMediaLoginButton, {
          onClick: federatedSignInClick,
          provider: SocialMediaProvider.Facebook
        }) : null, googleSignInAvailable ? jsx(SocialMediaLoginButton, {
          onClick: federatedSignInClick,
          provider: SocialMediaProvider.Google
        }) : null, appleSignInAvailable ? jsx(SocialMediaLoginButton, {
          onClick: federatedSignInClick,
          provider: SocialMediaProvider.Apple
        }) : null]
      }))]
    }))
  }));
};
export { ForgotPassword, Login as default };